import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {

  private readonly contentScrollToTopEvent: Subject<HTMLElement | undefined> = new Subject<HTMLElement | undefined>();

  public contentScrollToTop(anchor?: HTMLElement): void {
    this.contentScrollToTopEvent.next(anchor);
  }

  public getContentScrollToTopEvent(): Observable<HTMLElement | undefined> {
    return this.contentScrollToTopEvent.asObservable();
  }
}
